/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import AppLayout from '@/layouts/AppLayout.vue'
import DishListWrapper from '@/pages/dishes/DishListWrapper.vue'

// import dishesListEdit from '@/pages/dishes/dishesListEdit.vue'

export const dishesRouter = {
  children: [
    {
      component: DishListWrapper,
      meta: {
        title: 'Potrawy',
      },
      name: 'DishesList',
      path: 'list/',
      props: true,
    },
    // {
    //   path: 'edit/:dishId(\\d+)',
    //   name: 'DishesListEdit',
    //   component: dishesListEdit,
    //   meta: {
    //     title: 'Edycja potrawy'
    //   }
    // },
    // {
    //   path: 'add/',
    //   name: 'dishesListAdd',
    //   component: dishesListEdit,
    //   meta: {
    //     title: 'Dodawanie potrawy'
    //   }
    // }
  ],
  component: AppLayout,
  meta: {
    auth: true,
  },
  name: 'dishes',
  path: '/dishes',
  props: true,
}
